<template>
  <div class="content">
    <div class="container-fluid">
      <!-- Add navigation tabs -->
      <ul class="nav nav-tabs mb-3">
        <li class="nav-item">
          <a class="nav-link pointer text-secondary" :class="{ active: activeTab === 'customerSettings' }"
            @click="activeTab = 'customerSettings'">
            Müşteri Ayarları
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link pointer text-secondary" :class="{ active: activeTab === 'customerSummary' }"
            @click="activeTab = 'customerSummary'">
            Oyuncu İşem Özeti
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link pointer text-secondary" :class="{ active: activeTab === 'customerBonusSettings' }"
            @click="activeTab = 'customerBonusSettings'">
            Bonus Ayarları
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link pointer text-secondary" :class="{ active: activeTab === 'customerBonusSummary' }"
            @click="activeTab = 'customerBonusSummary'">
            Bonus Özeti
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link pointer text-secondary" :class="{ active: activeTab === 'customerConsensus' }"
            @click="activeTab = 'customerConsensus'">
            Mutakabat İşlemleri
          </a>
        </li>

      </ul>

      <!-- Customer Edit Form -->
      <div class="row" v-show="activeTab === 'customerSettings'">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <h4 class="card-title">Oyuncu Düzenle</h4>
              <p class="card-category">Oyuncuyu düzenleyin. Rapor tarafından oluşturulan gsm numarası değiştirilemez.
              </p>

              <form class="m-5">
                <div class="row">

                  <div class="col-md-4">
                    <base-input type="text" label="GSM" placeholder="" v-model="customer.gsm" :disabled="true">
                    </base-input>
                  </div>

                  <div class="col-md-4">
                    <base-input type="text" label="İsim" placeholder="İsmini giriniz" v-model="customer.name">
                    </base-input>
                  </div>

                  <div class="col-md-4">
                    <base-input type="text" label="Soyisim" placeholder="Soyismini giriniz" v-model="customer.surname">
                    </base-input>
                  </div>

                  <div class="col-md-4">
                    <base-input type="text" label="Telefon Numarası" placeholder="Telefon Numarası"
                      v-model="customer.fullPhone">
                    </base-input>
                  </div>


                </div>

                <div class="row">
                  <div class="col-md-12">
                    <base-input type="text" label="Bayii" placeholder="" v-model="customer.dealer.title"
                      :disabled="true">
                    </base-input>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Grup</label>
                      <select class="form-control" v-model="customer.affiliateGroup._id">
                        <option value="">Grup Seçiniz</option>
                        <option v-for="group in affiliateGroups" :key="group._id" :value="group._id">
                          {{ group.title }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>


                <div class="text-center pt-5">
                  <button type="submit" class="btn btn-info btn-fill float-right" @click="updateCustomer()">
                    Güncelle
                  </button>
                </div>
                <div class="clearfix"></div>
              </form>
            </template>
          </card>

        </div>
      </div>



      <!-- Customer Summary Form -->
      <div class="row" v-show="activeTab === 'customerSummary'">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <h4 class="card-title mb-3">(#{{ customer.gsm }}) {{ customer.name }} {{ customer.surname }} Müşterinin
                Haftalık Özeti
              </h4>

              <div class="row mt-2">
                <div class="col-md-12">

                  <!-- Machine Cards -->
                  <div v-for="(report, index) in customer.customerSummaryByReport" :key="index" class="card mb-4">
                    <div class="card-body">

                      <!-- Basic Info -->
                      <div class="row mb-3">
                        <div class="col-md-2">
                          <div class="justify-content-center">
                            <label>Hafta</label>
                            <div class=" d-flex ">{{ getWeekFromReportTitle(report.reportTitle) }}</div>

                          </div>
                        </div>
                        <div class="col-md-2">
                          <div class="justify-content-center">
                            <label>Toplam Yatırılan Para</label>
                            <div class=" d-flex ">{{ numeral(report.totalDeposit).format('0,0.00') }} TL</div>
                          </div>
                        </div>
                        <div class="col-md-2">
                          <div class="justify-content-center">
                            <label>Toplam Çevirim</label>
                            <div class=" d-flex ">{{ numeral(report.totalConversion).format('0,0.00') }} TL</div>
                          </div>
                        </div>

                        <div class="col-md-2">
                          <div class="justify-content-center">
                            <label>Toplam İade</label>
                            <div class=" d-flex ">{{ numeral(report.totalRefundedAmount).format('0,0.00') }} TL</div>
                          </div>
                        </div>

                        <div class="col-md-2">
                          <div class="justify-content-center">
                            <label>Toplam İkramiye Hesaba Aktarılan Para</label>
                            <div class=" d-flex ">{{ numeral(report.totalProfitToDeposit).format('0,0.00') }} TL</div>
                          </div>
                        </div>

                        <div class="col-md-2">
                          <div class="justify-content-center">
                            <label>Toplam Hesaptan Para Çekme</label>
                            <div class=" d-flex ">{{ numeral(report.totalWithdrawal).format('0,0.00') }} TL</div>
                          </div>
                        </div>
                      </div>


                    </div>
                  </div>

                </div>
              </div>

            </template>
          </card>
        </div>
      </div>


      <!-- Customer Bonus Settings Edit Form -->
      <div class="row" v-show="activeTab === 'customerBonusSettings'">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <h4 class="card-title">Oyuncu Bonus Ayarları</h4>
              <p class="card-category">Oyuncuya özel bonus ayarlarını düzenleyin. Oynanma aralığı ekleyerek ,ne kadar
                bonus
                verileceğini yönetebilirsiniz.</p>
              <p class="card-category">Aralık ayarları şöyle olmalıdır. <br>50.000 TL - 100.000 TL = %1 bonus<br>
                100.000 TL - 200.000 TL = %2 bonus<br> 200.000 TL - 300.000 TL = %3 bonus <br> Oynanan miktar, minimum
                çevirime eşit olabilir, maksimum çevirime eşit olamaz. Aralık bırakmamak önemlidir.</p>

              <form>
                <div class="row">
                  <div class="col-md-12">
                    <label>Çevirim Aralıkları</label>

                    <!-- Machine Cards -->
                    <div v-for="(setting, index) in customer.bonusSettings" :key="index" class="card mb-4">
                      <div class="card-body">
                        <div class="d-flex justify-content-between mb-3">
                          <h5 class="card-title">#{{ index + 1 }}</h5>
                          <button class="btn btn-danger btn-sm btn-fill" @click="removeBonusSetting(index)">
                            <i class="fa fa-trash"></i> Sil
                          </button>
                        </div>

                        <!-- Basic Info -->
                        <div class="row mb-3">
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Minimum Çevirim (TL) </label>
                              <input type="number" class="form-control" v-model="setting.minCover"
                                placeholder="Minimum Çevirim">
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Maksimum Çevirim (TL)</label>
                              <input type="number" class="form-control" v-model="setting.maxCover"
                                placeholder="Maksimum Çevirim">
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Bonus Oranı (%)</label>
                              <input type="number" min="0" step="0.01" max="5" class="form-control"
                                v-model="setting.bonusRate" placeholder="Bonus Oranı">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="text-center mb-4">
                      <button class="btn btn-primary" @click="addBonusSetting()">
                        <i class="fa fa-plus"></i> Yeni Aralık Ekle
                      </button>
                    </div>
                  </div>
                </div>

                <div class="text-center">
                  <button type="submit" class="btn btn-info btn-fill mb-3" @click="updateCustomer()">
                    <i class="fa fa-save"></i> Bonus Ayarlarını Güncelle
                  </button>
                </div>
              </form>
            </template>
          </card>
        </div>
      </div>

      <!-- Customer Bonus Summary Edit Form -->
      <div class="row" v-show="activeTab === 'customerBonusSummary'">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <h4 class="card-title mb-3">(#{{ customer.gsm }}) {{ customer.name }} {{ customer.surname }} Müşterinin
                Bonus Yükleme Özeti
              </h4>

              <div class="row mt-2">
                <div class="col-md-12">

                  <!-- Machine Cards -->
                  <div v-for="(report, index) in customer.customerSummaryByReport" :key="index" class="card mb-4">
                    <div class="card-body">

                      <!-- Basic Info -->
                      <div class="row mb-3">
                        <div class="col-md-2">
                          <div class="justify-content-center">
                            <label>Hafta</label>
                            <div class=" d-flex ">{{ getWeekFromReportTitle(report.reportTitle) }}</div>

                          </div>
                        </div>

                        <div class="col-md-2">
                          <div class="justify-content-center">
                            <label>Toplam Çevirim</label>
                            <div class=" d-flex ">{{ numeral(report.totalConversion).format('0,0.00') }} TL</div>
                          </div>
                        </div>

                        <div class="col-md-7 ">
                          <div v-for="(bonus, index) in report.bonuses" :key="index"
                            class="justify-content-center text-center">
                            <label>{{ bonusTypeMap[bonus.bonusType] }}</label>
                            <div class="d-flex justify-content-center">{{ numeral(bonus.amount).format('0,0.00') }} TL
                            </div>
                          </div>

                        </div>
                      </div>


                    </div>
                  </div>

                </div>
              </div>

            </template>
          </card>
        </div>
      </div>



      <!-- Customer Consensus Edit Form -->
      <div class="row" v-show="activeTab === 'customerConsensus'">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <h4 class="card-title"> (#{{ customer.gsm }}) {{ customer.name }} {{ customer.surname }} Müşteri Mutakabat
                İşlemleri</h4>
              <p class="card-category">Mütabakat raporu hazırlayın.</p>

              <form>
                <div class="row">
                  <div class="col-md-12">

                    <!-- Machine Cards -->
                    <div class="card-body">
                      <div class="d-flex justify-content-between mb-3">
                        <h5 class="card-title"> </h5>

                      </div>

                      <!-- Basic Info -->
                      <div class="row mb-3 justify-content-center align-items-center">
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>Mütabakat Tarihi Aralığı </label>

                            <select class="form-control" v-model="selectedMonth">
                              <option v-for="month in months" :key="month.id" :value="month.value">
                                {{ month.title }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-group">
                            <label></label>
                            <button class="btn btn-primary d-flex align-items-center justify-content-center gap-2"
                              @click="createConsensus(setting)">
                              <i class="fa fa-plus"></i>
                              <span class="d-none d-md-block ml-2">Mütabakat Oluştur</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>


                  </div>
                </div>
                <!-- 
                <div class="text-center">
                  <button type="submit" class="btn btn-info btn-fill mb-3" @click="updateCustomer()">
                    <i class="fa fa-save"></i> Bonus Ayarlarını Güncelle
                  </button>
                </div> -->
              </form>

              <!--- Customer Consensus -->
              <div v-for="(consensus, index) in customerConsensus" :key="index" class="card mb-4">
                <div class="card-body">

                  <!-- Basic Info -->
                  <div class="row mb-3">
                    <div class="col-md-2">
                      <div class="justify-content-center">
                        <label>Mütabakat Oluşturma Tarihi</label>
                        <div class=" d-flex ">{{ moment(consensus.createdAt).format('DD.MM.YYYY') }}</div>
                        <label class="mt-2">Mütabakat Referans No</label>
                        <div class=" d-flex ">{{ consensus.refNo }}</div>

                      </div>
                    </div>

                    <div class="col-md-8">
                      <div class="justify-content-center">
                        <label>Açıklama</label>
                        <div class=" d-flex ">{{ consensus.description }}</div>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="justify-content-center">
                        <label>Dosyayı İndir</label>
                        <div class=" d-flex ">
                          <a @click="downloadConsensus(consensus)" target="_blank" class="btn btn-primary">
                            <i class="fa fa-download"></i> İndir
                          </a>
                        </div>
                      </div>
                    </div>




                  </div>


                </div>
              </div>
            </template>
          </card>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import CollectionService from "../../services/collection.service.js";
import numeral from 'numeral';
import moment from 'moment';
const bonusTypeMap = {
  'BONUS_DEPOSIT': 'Bonus Bakiye Yüklendi',
  'BONUS_GIFT': 'Bonus Hediye Olarak Verildi',
  'BONUS_DELAYED': 'Haftaya Devir',
  'NOT_REWARDED': 'Bonus Hakediş Yok',
  'PENDING': 'İşlem Bekliyor',
  'PENDING_LOADING': 'Bonus Yüklenmesi Bekleniyor',
  'DELAYED_BONUS_REWARDED': 'Sonraki Hafta Ödemesi Yapıldı',
  'BONUS_DEPOSIT_TO_BANK': 'Müşterinin Bankasına Yüklendi'
};

export default {
  components: {
    Card
  },
  data() {
    return {
      id: null,
      customer: {
        gsm: "",
        name: "",
        fullPhone: "",
        surname: "",
        bonusSettings: [],
        isActive: true,
        customerSummaryByReport: []
      },
      activeTab: 'customerSettings',
      customerBonusSummary: [],
      numeral: numeral,
      bonusTypeMap: bonusTypeMap,
      months: [],
      selectedMonth: null,
      customerConsensus: [],
      moment: moment,
      affiliateGroups: []
    }
  },
  mounted() {
    this.id = window.location.href.split('/').at(-1);
    this.getCustomer();
    this.getCustomerConsensus();
    this.generateMonths();
    this.getAffiliateGroups();
  },
  methods: {
    getCustomer() {
      CollectionService.getCollectionItemWithId('customer', this.id).then((res) => {
        if (!res.customer.affiliateGroup) {
          res.customer.affiliateGroup = { _id: null };
        }
        this.customer = res.customer;
      })
    },
    getAffiliateGroups() {
      let q = {};
      let p = {};
      let o = { skip: 0, limit: 1000, sort: { title: 1 } }

      let query = `q=${JSON.stringify(q)}&p=${JSON.stringify(p)}&o=${JSON.stringify(o)}`

      CollectionService.getCollection('affiliate-group', query).then((res) => {
        if (res.success == true) {
          this.affiliateGroups = res.affiliateGroups;
        } else {
          console.log('error fetching affiliate groups');
        }
      })
    },
    updateCustomer() {

      this.customer.bonusSettings = this.customer.bonusSettings.map(setting => ({
        ...setting,
        minCover: parseFloat(setting.minCover),
        maxCover: parseFloat(setting.maxCover),
        bonusRate: parseFloat(setting.bonusRate),

      }));

   
      let payload = {
        ...this.customer,
      }

      if (payload.affiliateGroup._id == null) {
        delete payload.affiliateGroup;
      }

      console.log(payload);

      delete payload.dealer;





      CollectionService.updateCollectionItem('customer', this.customer._id, payload).then((res) => {
        if (res.success == true) {
          this.notifyVue('bottom', 'right', 'success', "Müşteri Güncellendi")
          //this.$router.push(`/admin/customers`);
        } else {
          this.notifyVue('bottom', 'right', 'danger', res.message || res.error)
        }
      }).catch(err => {
        this.notifyVue('bottom', 'right', 'danger', JSON.parse(err).error)
      })
    },
    notifyVue(verticalAlign, horizontalAlign, type, message) {
      this.$notifications.notify(
        {
          message: JSON.stringify(message),
          icon: '',
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type
        })
    },
    addBonusSetting() {
      this.customer.bonusSettings.push({
        minCover: 0,
        maxCover: 0,
        bonusRate: 0
      })
    },
    removeBonusSetting(index) {
      this.customer.bonusSettings.splice(index, 1);
    },
    getWeekFromReportTitle(reportTitle) {
      const dateString = reportTitle.split('_')[1].split('.')[0];

      const day = dateString.slice(0, 2);
      const month = dateString.slice(2, 4);
      const year = dateString.slice(4, 8);

      return `${day}.${month}.${year}`;
    },
    generateMonths() {
      const months = [];
      let currentDate = new Date();

      // Set to the end of current month
      currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

      // Generate 12 months
      for (let i = 0; i < 12; i++) {
        const endDate = new Date(currentDate);
        const startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1); // First day of month

        const formattedStartDate = startDate.toLocaleDateString('tr-TR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
        const formattedEndDate = endDate.toLocaleDateString('tr-TR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });

        months.push({
          id: i,
          title: `${formattedStartDate} - ${formattedEndDate}`,
          startDate: startDate,
          endDate: endDate,
          value: moment(startDate).format('DDMMYYYY')
        });

        // Move to the previous month
        currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);
      }

      this.months = months;
      this.selectedMonth = this.months[0].value; // Select the most recent month by default
    },
    createConsensus(setting) {
      const payload = {
        startDate: this.selectedMonth,
        customerId: this.customer._id
      }

      CollectionService.postWidthAuth('customer/consensus', payload).then((res) => {
        if (res.success == true) {
          this.notifyVue('bottom', 'right', 'success', "Mütabakat Oluşturuldu")
          this.getCustomerConsensus();
          const fileName = res.fileName;

          CollectionService.getCollection('entity/get-consensus-file?fileName=' + fileName).then((res) => {
            // Create blob from base64 data
            const byteCharacters = atob(res.data);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });

            // Create download link and trigger download
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }).catch((err) => {
            this.notifyVue('bottom', 'right', 'danger', err.message || err.error)
          })

        } else {
          this.notifyVue('bottom', 'right', 'danger', res.message || res.error)
        }
      })
    },
    downloadConsensus(consensus) {
      const { fileName } = consensus;
      CollectionService.getCollection('entity/get-consensus-file?fileName=' + fileName).then((res) => {
        // Create blob from base64 data
        const byteCharacters = atob(res.data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });

        // Create download link and trigger download
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(link.href);
      }).catch((err) => {
        this.notifyVue('bottom', 'right', 'danger', err.message || err.error)
      })
    },
    getCustomerConsensus() {
      let q = {};
      let p = {};
      let o = { skip: 0, limit: 1000, sort: { createdAt: 1 } }

      let query = `q=${JSON.stringify(q)}&p=${JSON.stringify(p)}&o=${JSON.stringify(o)}`
      CollectionService.getCollection(`customer/${this.id}/consensus`, query).then((res) => {
        this.customerConsensus = res.consensus;
      })
    }
  }
}
</script>
<style>
.nav-tabs .nav-link {
  cursor: pointer;
}

.attributes-container {
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 15px;
  background-color: #f8f9fa;
}

.attributes-container .form-control-sm {
  width: 45%;
  /* Adjust as needed */
}

.attributes-container .btn-sm {
  padding: 0.25rem 0.5rem;
}
</style>